import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { changeLoading } from '../store';
import { IsAlert } from '../atoms/IsAlert';
import { forgotPassword } from '../services';
import ArrowLeftIcon from '../assets/img/custom/arrow-left.svg';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required('Email is required')
      .email('Must be a valid email format'),
  });
  const formOptions = { resolver: yupResolver(validationSchema) };
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm(formOptions);
  const onSubmit = async (data) => {
    try {
      dispatch(changeLoading(true));
      const response = await forgotPassword(data);

      if (response.meta.total > 0) {
        dispatch(changeLoading(false));
        IsAlert.fire({
          title: 'Success',
          text: 'Verification Email Sent',
          icon: 'success',
          showCancelButton: false,
          focusConfirm: true,
          confirmButtonText: 'Done',
        }).then(function (isConfirm) {
          if (isConfirm.isConfirmed) {
            navigate('/email-sent');
          }
        });
      }
    } catch (error) {
      dispatch(changeLoading(false));
      IsAlert.fire({
        title: 'Error',
        text: error?.response?.data?.message ?? 'An unexpected error occurred.',
        icon: 'error',
        showCancelButton: false,
        focusConfirm: true,
        confirmButtonText: 'Confirm',
      });
    }
  };

  return (
    <div className="wrap-content signin">
      <div className="row h-100">
        <div className="col-12 h-100 position-relative form-parent">
          <div className="d-flex align-items-center justify-content-center form-wrap px-5 px-md-0">
            <form method="post" onSubmit={handleSubmit(onSubmit)}>
              <div className="d-flex align-items-center justify-content-center mb-3">
                <span className="pe-1 text-gray fs-3 text-center fw-bold">
                  Reset Your Password
                </span>
              </div>
              <div className="d-flex align-items-center justify-content-center mb-5">
                <span className="pe-1 text-gray text-center fz-14">
                  Enter your email address and we will sent further instruction.
                </span>
              </div>
              <div className="mb-3">
                <label className="form-labe fz-12 fw-bold">Email</label>
                <input
                  className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                  {...register('email', {
                    required: true,
                    pattern: /^\S+@\S+$/i,
                  })}
                  type="email"
                />
                <div className="invalid-feedback d-none">
                  Email / phone number is required
                </div>
              </div>
              <button type="submit" className="btn w-100 fw-semibold btn-fill">
                Reset Password
              </button>
              <div className="d-flex align-items-center justify-content-center mt-5 fz-14 ask">
                <span className>
                  <Link
                    to="/"
                    className="link-dark d-flex align-items-center justify-content-center fw-semibold"
                  >
                    <div className="img-wrap me-1">
                      <img src={ArrowLeftIcon} alt="img-arrow-left" />
                    </div>
                    Back to log in
                  </Link>
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
